import posthog from 'posthog-js';

// Runs once per page load, before hydration (Next instrumentation-client
// convention). Requests go through the /ingest rewrite in next.config.ts so
// ad blockers don't drop them and the CSP stays same-origin.
// Session replay is switched on server-side: PostHog → Settings → Session replay.
const key = process.env.NEXT_PUBLIC_POSTHOG_KEY;

if (key) {
  posthog.init(key, {
    api_host: '/ingest',
    // Real PostHog UI origin, so toolbar/deep links work despite the proxy.
    // EU-region account: change to https://eu.posthog.com (and see next.config.ts).
    ui_host: 'https://us.posthog.com',
    defaults: '2026-06-25',
  });
}
